import React from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { ActivityLogInterface, CommandActivity } from '../../../../types/activityLog';

interface ActionsColumnProps {
  record: ActivityLogInterface;
  onClickViewDetail: (record?: ActivityLogInterface) => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { record, onClickViewDetail } = props;

  return (
    <Space size="small">
      {record.command === CommandActivity.UPDATE && (
        <Button
          className="view-detail"
          icon={<EyeOutlined />}
          onClick={() => {
            if (onClickViewDetail) {
              onClickViewDetail(record);
            }
          }}
        />
      )}
    </Space>
  );
});
